<template>
    <div class="h-screen flex w-full bg-grad">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="https://img.icons8.com/fluent/256/000000/zoom.png" alt="graphic-maintenance" class="mx-auto mb-4">
            <h1 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">Zoom fue agregado éxitosamente</h1>
            <p class="sm:mx-0 mx-4 mb-6 ">Espera mientras te re-direccionamos a Evolugy.</p>
        </div>
    </div>
</template>

<script>
import axios from '../../http/axios/index.js'

export default {
  data () {
    return {
      value1: '',
      activeLoading: true,
    }
  },
  mounted: function() {
        let parameters = this.$route.query
        console.log(parameters);
        if(parameters.code){
          this.getZoomData(parameters.code);
        } else {
          alert('no response code');
        }
    },
  methods: {
    getZoomData(code){
      const cloudFunctionUrl = 'https://us-central1-evolugy2020.cloudfunctions.net/zoomCode?code='+code;
      console.log(code);
      axios.post(cloudFunctionUrl)
        .then((response) => {
            console.log(response);
        })
        .catch((error) => { return(error) });
    }
  }
}
</script>

<style scoped>
.bg-grad{
background: rgb(255,255,255);
background: -moz-radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(180,180,180,1) 100%);
background: -webkit-radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(180,180,180,1) 100%);
background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(180,180,180,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#b4b4b4",GradientType=1);
}
.content-div {
  width: 200px;
  height: 200px;
  box-shadow: 0px 6px 25px -10px rgba(0,0,0,.1);
  border-radius: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  font-size: .6rem
  }
</style>